/**
 * A share URL, styled the way it reads everywhere else in the app: the
 * domain/path prefix muted, the token bold — so the part a founder actually
 * checks (and pastes) is what draws the eye.
 */
export function ShareUrlLabel({ url, className }: { url: string; className?: string }) {
  const splitAt = url.lastIndexOf('/')
  const prefix = splitAt >= 0 ? url.slice(0, splitAt + 1) : url
  const token = splitAt >= 0 ? url.slice(splitAt + 1) : ''

  return (
    <span className={className}>
      <span className="text-muted-foreground">{prefix}</span>
      <span className="font-semibold">{token}</span>
    </span>
  )
}
